import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const APPOINTMENT_TYPES = ['CEO', 'Board Director', 'Advisory Board', 'Strategic Consultancy'] as const;
export function ContactPortal() {
  const [name, setName] = useState('');
  const [organization, setOrganization] = useState('');
  const [appointmentType, setAppointmentType] = useState<string>(APPOINTMENT_TYPES[0]);
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    window.setTimeout(() => {
      setSubmitting(false);
      setName('');
      setOrganization('');
      setAppointmentType(APPOINTMENT_TYPES[0]);
      setMessage('');
      toast.success('Inquiry received. Stephanie\u2019s office will respond shortly.');
    }, 700);
  };
  return <section id="contact" className="bg-slate-50 py-24 lg:py-32" data-id="element-60" data-mp="3mrlncwidgxuo">
      <div className="max-w-content mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16" data-id="element-61" data-mp="3roubddq7bw3u">
        <div data-id="element-62" data-mp="jcce597gwob">
          <SectionHeading eyebrow="10 — Board Inquiry" title="Direct Contact Portal" description="For CEO, board director, advisory board, or strategic consultancy inquiries, reach out directly or submit the form." data-id="element-63" data-mp="isuupngwaat" />

          <div className="mt-10 space-y-5" data-id="element-64" data-mp="ab8avhf7eot2">
            <div className="flex items-center gap-4" data-id="element-65" data-mp="e9ftkht8a06w">
              <MapPinIcon className="h-5 w-5 text-gold-dark shrink-0" strokeWidth={1.5} data-id="element-66" data-mp="ecbtgbomyyxz" />
              <span className="text-sm text-slate-700" data-id="element-67" data-mp="j7hfdai1gdm2">Luxembourg / United States</span>
            </div>
            <div className="flex items-center gap-4" data-id="element-68" data-mp="o6apqu213oi0">
              <MailIcon className="h-5 w-5 text-gold-dark shrink-0" strokeWidth={1.5} data-id="element-69" data-mp="2l28j4xtgockt" />
              <a href="mailto:stephanie.meyer@totalmedia.lu" className="text-sm text-slate-700 hover:text-gold-dark transition-colors duration-200" data-id="element-70" data-mp="2pz8gmkc8w70b">
                stephanie.meyer@totalmedia.lu
              </a>
            </div>
            <div className="flex items-center gap-4" data-id="element-71" data-mp="2rx8h2bb7jdod">
              <PhoneIcon className="h-5 w-5 text-gold-dark shrink-0" strokeWidth={1.5} data-id="element-72" data-mp="2ryt8vt650iij" />
              <a href="tel:+352621253609" className="text-sm text-slate-700 hover:text-gold-dark transition-colors duration-200" data-id="element-73" data-mp="2mwu5ijaedlll">
                +352 621 253 609
              </a>
            </div>
          </div>
        </div>

        <motion.form initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} onSubmit={handleSubmit} className="bg-white border border-slate-200 p-8 lg:p-10 space-y-5" data-id="element-74" data-mp="3ao9e2tsroz5a">
          <div className="grid sm:grid-cols-2 gap-5" data-id="element-75" data-mp="3fkztdewqzqpn">
            <div data-id="element-76" data-mp="34jktaxqop5p">
              <label htmlFor="inquiry-name" className="block text-xs font-semibold tracking-wide uppercase text-slate-500" data-id="element-77" data-mp="33zyli123elv">
                Name
              </label>
              <input id="inquiry-name" type="text" required value={name} onChange={event => setName(event.target.value)} className="mt-2 w-full border border-slate-300 bg-white px-4 py-3 text-sm text-navy focus:outline-none focus:border-gold transition-colors duration-200" placeholder="Your full name" data-id="element-78" data-mp="3pbhs02dgniky" />
            </div>
            <div data-id="element-79" data-mp="36i44ujfzogfw">
              <label htmlFor="inquiry-org" className="block text-xs font-semibold tracking-wide uppercase text-slate-500" data-id="element-80" data-mp="3bjbd0jm1nhn3">
                Organization
              </label>
              <input id="inquiry-org" type="text" required value={organization} onChange={event => setOrganization(event.target.value)} className="mt-2 w-full border border-slate-300 bg-white px-4 py-3 text-sm text-navy focus:outline-none focus:border-gold transition-colors duration-200" placeholder="Company or board" data-id="element-81" data-mp="2wmsvyhr9i3g2" />
            </div>
          </div>

          <div data-id="element-82" data-mp="3q6lwxuich8nb">
            <label htmlFor="inquiry-type" className="block text-xs font-semibold tracking-wide uppercase text-slate-500" data-id="element-83" data-mp="3q512s5zxzrpz">
              Appointment Type
            </label>
            <select id="inquiry-type" value={appointmentType} onChange={event => setAppointmentType(event.target.value)} className="mt-2 w-full border border-slate-300 bg-white px-4 py-3 text-sm text-navy focus:outline-none focus:border-gold transition-colors duration-200" data-id="element-84" data-mp="3h5ns5a030x3o">
              {APPOINTMENT_TYPES.map(type => <option key={type} value={type} data-id="element-85" data-mp="15i7lhg76csl7">
                  {type}
                </option>)}
            </select>
          </div>

          <div data-id="element-86" data-mp="1hziebvh0qsm9">
            <label htmlFor="inquiry-message" className="block text-xs font-semibold tracking-wide uppercase text-slate-500" data-id="element-87" data-mp="1hz08c74k1015">
              Message
            </label>
            <textarea id="inquiry-message" required rows={4} value={message} onChange={event => setMessage(event.target.value)} className="mt-2 w-full border border-slate-300 bg-white px-4 py-3 text-sm text-navy focus:outline-none focus:border-gold transition-colors duration-200 resize-none" placeholder="Tell us about the opportunity" data-id="element-88" data-mp="1mskzpgbn6vrd" />
          </div>

          <button type="submit" disabled={submitting} className="inline-flex items-center justify-center bg-navy px-7 py-3.5 text-sm font-semibold tracking-wide text-white hover:bg-navy-light transition-colors duration-200 disabled:opacity-60" data-id="element-89" data-mp="190ev8rhuqd7r">
            {submitting ? 'Sending…' : 'Submit Inquiry'}
          </button>
        </motion.form>
      </div>
    </section>;
}